enum MediaTypes {
  IMAGE = 'image',
  VIDEO = 'video',
}

export { MediaTypes }
